"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
/**
 * A card component used to hold content
 *
 */
const Card = (_a) => {
    var { children, href, newTab, src, alt, padded = undefined, centered = undefined, direction = "column", srcSet, sizes, wrapperProps } = _a, rest = __rest(_a, ["children", "href", "newTab", "src", "alt", "padded", "centered", "direction", "srcSet", "sizes", "wrapperProps"]);
    if (href) {
        const targets = newTab
            ? {
                target: "_blank",
                rel: "noopenner noreferrer",
            }
            : {};
        return (react_1.default.createElement(styled_1.StyledCard, Object.assign({ as: "a", href: href }, targets, rest, { link: true }),
            src ? react_1.default.createElement(styled_1.StyledImage, { src: src, sizes: sizes, srcSet: srcSet, alt: alt, direction: direction, wrapperProps: wrapperProps, effect: "blur" }) : react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement(styled_1.StyledContent, { padded: padded, centered: centered, direction: direction }, children)));
    }
    return (react_1.default.createElement(styled_1.StyledCard, Object.assign({}, rest),
        src ? react_1.default.createElement(styled_1.StyledImage, { src: src, sizes: sizes, srcSet: srcSet, alt: alt, direction: direction, wrapperProps: wrapperProps, effect: "blur" }) : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(styled_1.StyledContent, { padded: padded, centered: centered, direction: direction }, children)));
};
exports.Card = Card;
exports.default = exports.Card;
//# sourceMappingURL=Card.js.map